import {
  Card,
  CardContent,
  Typography,
  useTheme,
  Box,
  Stack
} from '@mui/material';
import { FC } from 'react';
import emptyImage from 'src/assets/image/Image-not-supported.png';

interface IProductPostCardProps {
  imageUrl?: string;
  title: string;
  description?: string;
  productLink?: string;
}

const ProductPostCard: FC<IProductPostCardProps> = ({
  imageUrl,
  title,
  description,
  productLink
}) => {
  const theme = useTheme();

  const handleCardClick = () => {
    if (productLink) {
      window.open(productLink, '_blank');
    }
  };

  return (
    <Card
      onClick={handleCardClick}
      elevation={0}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        height: '100%',
        border: '1px solid rgba(0, 0, 0, 0.1)',
        borderRadius: '12px',
        overflow: 'hidden'
      }}
    >
      {/* Card Content */}
      <CardContent
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'row',
          gap: 1,
          padding: 2,
          '&:last-child': {
            paddingBottom: 2
          }
        }}
      >
        {/* Product Image */}
        <Box
          component="img"
          src={imageUrl || emptyImage}
          alt={title}
          sx={{
            width: '60px',
            height: '60px',
            borderRadius: '8px',
            objectFit: 'cover',
            aspectRatio: '1 / 1'
          }}
          onError={(e) => {
            e.currentTarget.src = emptyImage;
          }}
        />
        <Stack gap={2}>
          {/* Product Title */}
          <Typography
            variant="subtitle2"
            sx={{
              fontWeight: 700,
              lineHeight: '1.4',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              minHeight: '2.8em'
            }}
            title={title}
          >
            {title}
          </Typography>

          {/* Description */}
          {description && (
            <Typography
              variant="body2"
              sx={{
                color: theme.palette.text.secondary,
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}
            >
              {description}
            </Typography>
          )}
          <Typography
            sx={{
              fontSize: '12px',
              fontWeight: 600,
              color: '#051C26',
              textDecoration: 'underline',
              textUnderlineOffset: '2px',
              cursor: 'pointer',
              '&:hover': {
                fontWeight: 600
              }
            }}
            onClick={() => {
              if (productLink) {
                window.open(productLink, '_blank', 'noopener,noreferrer');
              }
            }}
          >
            Link to source
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default ProductPostCard;
